<template>
  <div class="page">
    <div class="title">INVOICE</div>
    <div class="top">
      <div class="topLeft">
        <!-- <div>シャープ株式会社</div>
        <div>{{ shipment.displayBuName }}</div>
        <div>{{ shipment.displayWarehouseName }}</div> -->
      </div>
      <div class="topRight">
        <div>Issue Date:{{ request.issueDate }}</div>
        <div>
          Refference No:{{ request.refNo }}
          {{
            request.issuePrintedCount > 0
              ? "-R" + request.issuePrintedCount
              : ""
          }}
        </div>
      </div>
    </div>

    <div class="middle">
      <div class="introductionLeft">
        <div>
          <div>
            BILLING TO:
            <span style="font-weight: bold; margin-left: 5px; font-size: 24px">
              {{ request.providerName }}
            </span>
          </div>
          <div style="margin: 20px 0" class="boldLine"></div>
        </div>
        <div>
          <div>{{ request.providerAddress }}</div>
        </div>
      </div>
      <div class="introductionRight">
        <div>Payment due by</div>
        <div>
          <span style="font-weight: bold; margin-left: 5px; font-size: 16px"
            >SHARP JUSDA LOGISTICS CORPORATION</span
          >
        </div>
        <div></div>
        <div></div>
        <div style="margin-top: 20px">Import dept.</div>
        <div>1 Takumi-cho, Sakai-ku, Sakai-city,</div>
        <div>Osaka 590-8522,JP</div>
        <div></div>
        <div style="margin-top: 20px; font-size: 15px">
          TEL：０７２－２８２－１４３９
        </div>
        <div></div>
        <div style="margin-top: 20px; font-size: 15px">
          FAX：０７２－２８２－１５８０
        </div>
      </div>
    </div>

    <div class="bottom">
      <div class="bottomLeft">
        <div>{{ request.paymentCondition }}</div>
      </div>
      <div class="bottomRight"></div>
    </div>

    <div class="shipmentInfo">
      <div class="basicInfo">USD1$=JPY{{ request.currencyRate }}</div>
      <div class="basicInfo">B/L No:{{ request.blNo }}</div>
      <div class="basicInfo">INV.No No:{{ request.invoiceNos }}</div>
      <div class="rightInfo">{{ request.pageNo }}</div>
    </div>

    <div class="datatable">
      <table>
        <tr>
          <td class="centerText">Item</td>
          <td class="centerText">Quantity</td>
          <td class="centerText">Unit</td>
          <td class="centerText" style="width: 100px">Unit price</td>
          <td class="centerText" style="width: 100px">TOTAL（USD)</td>
          <td class="centerText">Remarks</td>
        </tr>

        <!-- <tr v-if="request.index === 1">
          <td>●航空運賃</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr> -->

        <!-- <tr
          :key="charge.id"
          v-for="charge in request.charges.filter((c) => c.freight)"
        >
          <td>{{ charge.chargeItem }}</td>
          <td>{{ charge.qty }}</td>
          <td>{{ charge.unit }}</td>
          <td>{{ charge.unitPrice }}</td>
          <td class="amountFormat">
            {{ charge.totalPrice | currency({ fractionCount: 2 }) }}
          </td>
          <td>{{ charge.comment }}</td>
        </tr> -->

        <!-- <tr v-if="request.index === 1">
          <td>●輸入費用：日本</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr> -->

        <tr :key="charge.id" v-for="charge in request.charges">
          <td>
            {{ charge.chargeItem }}
            <span
              v-if="charge.additional && charge.comment === 'Warehouse Fee'"
            >
              -Warehouse Fee
            </span>
            <span v-if="charge.additional && charge.comment === 'High way Fee'">
              -High way Fee
            </span>
          </td>
          <td>
            {{ isChargeTypeTitle(charge) ? null : charge.qty }}
          </td>
          <td>{{ isChargeTypeTitle(charge) ? null : charge.unit }}</td>
          <td>{{ charge.unitPrice }}</td>
          <td class="amountFormat" v-if="isChargeTypeTitle(charge)"></td>
          <td v-if="!isChargeTypeTitle(charge)">
            {{ charge.totalPrice | currency({ fractionCount: 2 }) }}
          </td>
          <td>{{ charge.comment }}</td>
        </tr>

        <tr v-for="(item, index) in blankRowsCount" :key="'tr' + index">
          <td>&nbsp;&nbsp;</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>

        <tr v-if="request.isLast">
          <td>Total</td>
          <td></td>
          <td></td>
          <td></td>
          <td class="amountFormat">
            {{ request.chargesTotal | currency({ fractionCount: 2 }) }}
          </td>
          <td></td>
        </tr>
      </table>
    </div>
    <div>
      <table class="bottomInfo">
        <tr>
          <td>A/C NAME：</td>
          <td>SHARP JUSDA LOGISTICS CORPORATION</td>
        </tr>
        <tr>
          <td>A/C NO:</td>
          <td>5444071</td>
        </tr>
        <tr>
          <td>BANK NAME:</td>
          <td>Mizuho Bank, Ltd. Osaka Corporate Banking Branch</td>
        </tr>
        <tr>
          <td>BANK ADDRESS:</td>
          <td>4-2-1 Imabashi, Chuo-ku, Osaka-shi, Osaka 541-0042, Japan</td>
        </tr>
        <tr>
          <td>SWIFT CODE:</td>
          <td>MHCBJPJT</td>
        </tr>
        <tr>
          <td>DUE DATE:</td>
          <td>{{ request.dueDate }}</td>
        </tr>
      </table>
    </div>
    <div class="bottom">
      <div class="bottomLeft"></div>
      <div class="bottomRight">
        <div style="margin-bottom: 5px">SHARP JUSDA LOGISTICS CORPORATION</div>
        <div v-if="request.confirmed && operation !== 'CONFIRM'" class="mark">
          <img
            src="../../assets/img/newSign.jpg"
            alt="Signature"
            width="300px"
          />
        </div>
        <div class="boldLine"></div>
        <div>SENIOR MANAGER</div>
        <div>Import Dept.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["request", "operation", "chargesTotal"],
  data() {
    return {};
  },
  methods: {
    isChargeTypeTitle(charge) {
      return charge.chargeItem.indexOf("●") !== -1;
    },
  },
  computed: {
    blankRowsCount() {
      if (this.request.isLast) {
        return 13 - this.request.charges.length - 1;
      }
      return 0;
    },
    today() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return year + "年" + month + "月" + day + "日";
    },
    freightCharges() {
      return this.request.charges.filter((c) => c.freight);
    },
    otherCharges() {
      return this.request.charges.filter((c) => !c.freight);
    },
    freightChargesTotal() {
      return this.freightCharges
        .map((c) => c.totalPrice)
        .reduce((c, t) => {
          return (t += c);
        }, 0);
    },
    otherChargesTotal() {
      return this.otherCharges
        .map((c) => c.totalPrice)
        .reduce((c, t) => {
          return (t += c);
        }, 0);
    },
  },
};
</script>

<style scoped>
.bottomInfo {
  border: 0;
  margin-bottom: 20px;
}

.bottomInfo td {
  border: 0;
}

.title {
  display: block;
  text-align: center;
  font-size: 25px !important;
}

.top {
  display: block;
}

.topLeft {
  font-size: 15px;
  display: inline-block;
  min-height: 40px;
}

.topRight {
  font-size: 15px;
  display: inline-block;
  float: right;
}

.introductionLeft {
  margin-top: 100px;
  font-size: 15px;
  width: 50%;
  display: inline-block;
  /* border: 1px dashed grey; */
}

.introductionRight {
  margin-top: 120px;
  font-size: 12px;
  width: 35%;
  display: block;
}

.middle {
  display: flex;
  justify-content: space-between;
}

.mark {
  width: 200px;
  height: 100px;
  background-image: url("../../assets/img/newSign.jpg");
  right: 100px;
  top: 150px;
  background-color: aqua;
}

.signature {
  border: 1px solid black;
  width: 75px;
  height: 100px;
  top: 250px;
  right: 40px;
  border-radius: 15px;
  position: absolute;
  text-align: center;
  padding-top: 10px;
}

.signatureLine {
  border-bottom: 1px solid black;
  width: 75px;
  height: 10px;
}

.amount {
  margin-top: 20px;
  width: 40%;
}

.space {
  display: flex;
  justify-content: space-between;
}

.totalAmountTitle {
  font-size: 30px;
}

.totalAmount {
  font-size: 30px;
}

.boldLine {
  display: block;
  width: 100%;
  border: 2px solid black;
}

.bottom {
  bottom: 0;
  margin-left: 20px;
  display: flex;
  justify-content: space-between;
}

.bottomLeft {
  margin-top: 30px;
  font-size: 10px;
  display: inline-block;
}

.bottomRight {
  font-size: 18px;
  display: inline-block;
}

table {
  margin: 40px 0 0 0;
  width: 100%;
  border: 1px solid white;
  border-collapse: collapse;
}

table td {
  border: 1px solid black;
  font-size: 18px !important;
}

.out {
  height: 0;
  border: 1px solid black;
  width: 100px;
  transform: rotate(190deg);
}

.blank {
  border: 1px solid white;
}

.blankBottom {
  border-bottom: 1px solid white;
}

.blankRight {
  border-top: 1px solid white;
  border-left: 1px solid white;
  border-bottom: 1px solid white;
}

.centerText {
  text-align: center;
}

.amountFormat {
  padding-right: 5px;
  text-align: right;
}

.datatable {
  margin-top: -70px;
  width: 100%;
}

.footer {
  width: 30%;
  display: block;
  font-size: 18px;
}

.amountNum {
  float: right;
}

.page {
  padding: 30px 30px;
  font-size: 12px;
}

.shipmentInfo {
  display: flex;
  padding: 20px 0;
  position: relative;
}

.basicInfo {
  font-size: 20px;
  margin: 20px;
}

.rightInfo {
  font-size: 20px;
  margin-right: 0px;
  margin-top: 20px;
  margin-left: 50px;
  position: absolute;
  right: 0px;
}

.summary {
  border: 1px grey dashed;
}
</style>
